var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#1EA35F",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8667 14.6036L7.53336 12.2702C7.41013 12.1455 7.24206 12.0753 7.0667 12.0753C6.89133 12.0753 6.72327 12.1455 6.60003 12.2702C6.34003 12.5302 6.34003 12.9436 6.60003 13.2036L9.39336 15.9969C9.65336 16.2569 10.0734 16.2569 10.3334 15.9969L17.4 8.93692C17.66 8.67692 17.66 8.26358 17.4 8.00358C17.2768 7.87882 17.1087 7.80859 16.9334 7.80859C16.758 7.80859 16.5899 7.87882 16.4667 8.00358L9.8667 14.6036Z",
    fill: "#1EA35F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenCheck);
export default __webpack_public_path__ + "static/media/icon-green-check.02cae59f0412940b65e1a8e4a6ee15e4.svg";
export { ForwardRef as ReactComponent };